<template>
  <div class="page-column">
    <Header />
    <!-- <Banner/> -->
    <ProgramSwiper />
    <RecentMatch :agencyId="-1" />
    <!-- <div style="background-color: #f4f4f4;text-align: center;width: 1200px;margin: 0 auto;">
      <img style="width:50%;float: left;height:150px;" src="https://static.daoba.com/880186366461.jpg"/>
      <img style="width:50%;float: left;height:150px;" src="https://static.daoba.com//861924122607.png"/>
    </div> -->
    <div style="background-color: #f4f4f4;text-align: center;">
      <img style="width:1200px;" src="https://static.daoba.com/880186366461.jpg"/>
    </div>
    <Footer />
    <BackTop />
  </div>
</template>

<script>
import Header from '../layout/Header.vue'
import Banner from '../layout/Banner.vue'
import ProgramSwiper from '../layout/ProgramSwiper.vue'
import RecentMatch from '@comm/components/RecentMatch.vue'
import Footer from '../layout/Footer.vue'
import BackTop from '@comm/components/public/BackTop'
export default {
  components: {
    Header,
    Banner,
    RecentMatch,
    Footer,
    ProgramSwiper,
    BackTop,
  },
  created () {},
}
</script>
<style lang="scss" scoped>
.page-column {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/daoba-match/views/match/Home.vue